import React from 'react';
import { CircleAlertIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { problemPoints } from '../data/framework';
export function ProblemSection() {
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-293" data-mp="30isixmr5drw4">
      <div className="mx-auto max-w-3xl" data-id="element-294" data-mp="2vq7nyhwi98r0">
        <SectionHeading eyebrow="The Problem" title="From Reviewing Endless References to Following a Structured Process" intro="You may already understand periodontal terminology, classification concepts, clinical findings, risk factors, and treatment principles. But knowing the individual concepts doesn’t automatically tell you how to organize the available information." data-id="element-295" data-mp="2vp6dofnbcqac" />

        <p className="mt-10 font-bold text-ink" data-id="element-296" data-mp="3ef5z8sjy3n90">You may find yourself:</p>
        <ul className="mt-4 divide-y divide-gum/15 rounded-2xl bg-gum-light px-5" data-id="element-297" data-mp="1p2auo9xpevkk">
          {problemPoints.map(p => <li key={p} className="flex gap-3 py-4 text-[16px] leading-relaxed text-ink sm:text-lg" data-id="element-298" data-mp="1k5ape18ohwui">
              <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-gum" aria-hidden="true" data-id="element-299" data-mp="jbahpax59vkh" />
              <span data-id="element-300" data-mp="o9tzr08man7k">{p}</span>
            </li>)}
        </ul>

        <div className="mt-10 space-y-3 text-center text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-301" data-mp="sc8hti4gpixs">
          <p className="font-serif text-2xl font-bold text-brand-dark" data-id="element-302" data-mp="x5tbwz2xpsrp">
            I designed Perio Blueprint™ to address this organizational gap.
          </p>
          <p data-id="element-303" data-mp="171wjwlkgwlmk">Not by promising instant diagnoses.</p>
          <p data-id="element-304" data-mp="174iu6syqtf8h">Not by replacing your clinical training.</p>
          <p data-id="element-305" data-mp="1c2u0wutqr9mh">
            But by giving you a <strong data-id="element-306" data-mp="1bzoclhsxsbrt">structured visual reference</strong> that helps you organize the knowledge you
            already have.
          </p>
        </div>

        <div className="mt-10" data-id="element-307" data-mp="3dtxhe0qbbiey">
          <CTAButton label="I Want to Organize My Periodontal Knowledge" data-id="element-308" data-mp="3duyqw0rojwuk" />
        </div>
      </div>
    </section>;
}